import React, { useState } from 'react';
import { Card } from 'antd';
import ClientList from '../client/ClientList';
import SingleReglement from './SingleReg';

const CreateRegWizard = ({ onCompleted, onCancel }) => {
  const [selectedClient, setSelectedClient] = useState(null);

  const handleSelectClient = (client) => {
    setSelectedClient(client);
  };

  if (!selectedClient) {
    return (
      <Card title="Sélectionner un Client" bordered={false}>
        <ClientList onSelectClient={handleSelectClient} />
      </Card>
    );
  }

  return (
    <SingleReglement
      draftClient={selectedClient}
      onCompleted={onCompleted}
      onClose={onCancel}
    />
  );
};

export default CreateRegWizard;












